import {
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { TermsResponse } from '@/api/terms.types.ts';
import { fetchTerms } from '@/api/api.terms.ts';
import { ApiError } from '@/api/error/api.errors.ts';

const useTermsQuery = (): UseSuspenseQueryResult<TermsResponse, ApiError> => {
  return useSuspenseQuery({
    queryKey: getQueryKey(),
    queryFn: fetchTerms,
  });
};

const getQueryKey = () => ['terms'];
useTermsQuery.getQueryKey = getQueryKey;

export default useTermsQuery;
